import { atom } from 'jotai';

import { categoryUpdateAtom } from '../_graphql/mutationCategoryUpdate';
import { categoryDetailQueryAtom } from '../_graphql/queryCategoryDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

// 🟣🟣🟣 PARAMS
export const $categoryId = settingsRouteParamAtom(
  ['/inventory/categories/:id'],
  'id',
);

// 🟢🟢🟢 REMOTE DATA
export const $remoteCategoryDetail = categoryDetailQueryAtom((get) => {
  const categoryId = get($categoryId);
  return {
    variables: {
      ids: categoryId ? [categoryId] : [],
    },
    skip: !categoryId,
  };
});

// 🟢🟢🟢 COMPUTED DATA
export const $isCategoryLoading = atom((get) => {
  const data = get($remoteCategoryDetail);
  return data?.isLoading ?? false;
});

export const $categoryError = atom((get) => {
  const data = get($remoteCategoryDetail);
  return data?.error ?? null;
});

// 🟠🟠🟠 ACTION -> UPDATE category
export const $updateCategory = categoryUpdateAtom({
  onSuccess: (get) => {
    get($remoteCategoryDetail).refetch?.();
  },
});
